@if (listing) {
<gallery-listing-card class="loh-card" [listing]="listing" [canSelect]="false" [isShortCard]="true"
    [hideOpenRentals]="shouldHideOpenRentals" [companyConfiguration]="companyConfiguration"
    (listingDetailsClicked)="onOpenHouseCardClicked()" (mediaViewerClicked)="onMediaViewerClicked($event)"
    (priceChangeClicked)="onOpenHouseCardClicked()">

    <ng-template #bodyExtraFooter>
        <div class="loh-card-footer" (click)="$event.stopPropagation(); onOpenHouseCardClicked()">

            <div class="loh-card-footer-block">

                <div class="loh-card-footer-icon-wrap">

                    <rpc-icon class="loh-card-footer-icon" [iconName]="'oh'">
                    </rpc-icon>

                </div>

                <div class="loh-card-footer-date">
                    {{openHouse.startDate | date: dateConstants.Formats.AngularPipeShortDateSlash}}
                </div>

                <div class="loh-card-footer-time">
                    {{openHouse.startDate | date: dateConstants.Formats.AngularPipeShortTimeWithoutPeriod}} -
                    {{openHouse.endDate | date: dateConstants.Formats.AngularPipeShortTimeWithoutPeriod}}
                </div>

            </div>

        </div>

    </ng-template>

</gallery-listing-card>
}